import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { UserStore } from '@core/stores';

export const clearAppSessionResolver: ResolveFn<boolean> = () => {
  const userStore = inject(UserStore);

  userStore.onReset();

  return true;
};
